/**
 * User: n.gorte
 * Date: 20.06.2022
 * Time: 15:52
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import '../css/legend.scss';

export const LayerLegend = ({ legends = [], onClose }) => {

    return (
        <div className="fliwas-map-legend-container">
            <ul className="fliwas-map-legend">
                {
                    legends.length === 0 && (
                        <li className="fliwas-map-legend__section-item">
                            <span>Keine Legenden gefunden</span>
                        </li>
                    )
                }
                {
                    legends.map(item => (
                        <li key={item.title} className={`fliwas-map-legend__section-item ${item.legendClass}`}>
                            <span className="fliwas-map-legend__section-item-title">{item.title} {item.legendTitleSuffix}</span>
                            <ul className="list-group fliwas-map-legend__item-list">
                                {
                                    item.legend.map((legendElem, i) => <LegendItem
                                        key={`${legendElem.label} - ${i}`} {...legendElem}/>)
                                }
                            </ul>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

LayerLegend.propTypes = {
    legends: PropTypes.array,
    onClose: PropTypes.func,
};

const LegendItem = ({ label, icon }) => {
    const { type, color, fillColor, url, borderWidth, style } = icon;
    return (
        <li className="fliwas-map-legend__item">
            {
                url && Array.isArray(url) && url.map(u => <img style={style} key={u} src={u}
                                                               className="fliwas-map-legend__item__image"/>)
            }
            {
                url && !Array.isArray(url) && <img style={style} src={url} className="fliwas-map-legend__item__image"/>
            }
            {
                !url && (
                    <LegendItemIcon
                        type={type}
                        style={style}
                        color={color}
                        fillColor={fillColor}
                        borderWidth={borderWidth}
                    />
                )
            }

            <span
                className="fliwas-map-legend__item__label"
                dangerouslySetInnerHTML={{ __html: label }}
            />
        </li>
    );
};

LegendItem.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.shape({
        type: PropTypes.oneOf(['area', 'line', 'point', 'custom']),
        url: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        color: PropTypes.string,
        fillColor: PropTypes.string,
        borderWidth: PropTypes.number,
    }).isRequired
};

const LegendItemIcon = ({ type, color, fillColor, borderWidth, style }) => {
    const className = `fliwas-map-legend__item__icon fliwas-map-legend__item__icon--${type}`;

    const _style = style ? style : {
        borderColor: color || 'transparent',
        backgroundColor: fillColor || 'transparent',
        borderWidth: borderWidth || (color ? '1px' : '0px')
    };

    return (
        <div className={className} style={_style}/>
    );
};

LegendItemIcon.propTypes = {
    type: PropTypes.oneOf(['area', 'line', 'point', 'custom']).isRequired,
    color: PropTypes.string,
    style: PropTypes.object,
    fillColor: PropTypes.string,
    borderWidth: PropTypes.number,
};



// WEBPACK FOOTER //
// ./js/components/LayerLegend.jsx